// This file is generated by packages/server/scripts/generate-api-cli-route-metadata.ts. Do not edit by hand.

export const API_ROUTE_METADATA = {
  "GET /agents": {
    "method": "GET",
    "path": "/agents",
    "pathParams": [],
    "queryParams": [
      "partial"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "record"
    }
  },
  "GET /agents/providers": {
    "method": "GET",
    "path": "/agents/providers",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "providers"
    }
  },
  "GET /agents/:agentId": {
    "method": "GET",
    "path": "/agents/:agentId",
    "pathParams": [
      "agentId"
    ],
    "queryParams": [
      "status",
      "versionId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agents/:agentId/clone": {
    "method": "POST",
    "path": "/agents/:agentId/clone",
    "pathParams": [
      "agentId"
    ],
    "queryParams": [],
    "bodyParams": [
      "authorId",
      "metadata",
      "newId",
      "newName"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /agents/:agentId/voice/speakers": {
    "method": "GET",
    "path": "/agents/:agentId/voice/speakers",
    "pathParams": [
      "agentId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "array"
    }
  },
  "POST /agents/:agentId/generate": {
    "method": "POST",
    "path": "/agents/:agentId/generate",
    "pathParams": [
      "agentId"
    ],
    "queryParams": [],
    "bodyParams": [
      "activeTools",
      "clientTools",
      "context",
      "instructions",
      "maxSteps",
      "memory",
      "messages",
      "model",
      "modelSettings",
      "output",
      "providerOptions",
      "requestContext",
      "requireToolApproval",
      "returnScorerData",
      "runId",
      "savePerStep",
      "scorers",
      "stopWhen",
      "structuredOutput",
      "system",
      "toolChoice",
      "toolsets",
      "tracingOptions",
      "untilIdle",
      "versions"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agents/:agentId/generate/vnext": {
    "method": "POST",
    "path": "/agents/:agentId/generate/vnext",
    "pathParams": [
      "agentId"
    ],
    "queryParams": [],
    "bodyParams": [
      "activeTools",
      "clientTools",
      "context",
      "instructions",
      "maxSteps",
      "memory",
      "messages",
      "model",
      "modelSettings",
      "output",
      "providerOptions",
      "requestContext",
      "requireToolApproval",
      "returnScorerData",
      "runId",
      "savePerStep",
      "scorers",
      "stopWhen",
      "structuredOutput",
      "system",
      "toolChoice",
      "toolsets",
      "tracingOptions",
      "untilIdle",
      "versions"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agents/:agentId/send-message": {
    "method": "POST",
    "path": "/agents/:agentId/send-message",
    "pathParams": [
      "agentId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agents/:agentId/queue-message": {
    "method": "POST",
    "path": "/agents/:agentId/queue-message",
    "pathParams": [
      "agentId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agents/:agentId/signals": {
    "method": "POST",
    "path": "/agents/:agentId/signals",
    "pathParams": [
      "agentId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agents/:agentId/threads/abort": {
    "method": "POST",
    "path": "/agents/:agentId/threads/abort",
    "pathParams": [
      "agentId"
    ],
    "queryParams": [],
    "bodyParams": [
      "resourceId",
      "threadId"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agents/:agentId/tools/:toolId/execute": {
    "method": "POST",
    "path": "/agents/:agentId/tools/:toolId/execute",
    "pathParams": [
      "agentId",
      "toolId"
    ],
    "queryParams": [],
    "bodyParams": [
      "data",
      "requestContext"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agents/:agentId/send-tool-approval": {
    "method": "POST",
    "path": "/agents/:agentId/send-tool-approval",
    "pathParams": [
      "agentId"
    ],
    "queryParams": [],
    "bodyParams": [
      "approved",
      "format",
      "messages",
      "requestContext",
      "resourceId",
      "resumeData",
      "streamOptions",
      "threadId",
      "toolCallId"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /agents/:agentId/suspended-runs": {
    "method": "GET",
    "path": "/agents/:agentId/suspended-runs",
    "pathParams": [
      "agentId"
    ],
    "queryParams": [
      "fromDate",
      "page",
      "perPage",
      "resourceId",
      "threadId",
      "toDate"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "runs"
    }
  },
  "POST /agents/:agentId/approve-tool-call-generate": {
    "method": "POST",
    "path": "/agents/:agentId/approve-tool-call-generate",
    "pathParams": [
      "agentId"
    ],
    "queryParams": [],
    "bodyParams": [
      "format",
      "model",
      "requestContext",
      "runId",
      "toolCallId"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agents/:agentId/decline-tool-call-generate": {
    "method": "POST",
    "path": "/agents/:agentId/decline-tool-call-generate",
    "pathParams": [
      "agentId"
    ],
    "queryParams": [],
    "bodyParams": [
      "format",
      "model",
      "reason",
      "requestContext",
      "runId",
      "toolCallId"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agents/:agentId/model": {
    "method": "POST",
    "path": "/agents/:agentId/model",
    "pathParams": [
      "agentId"
    ],
    "queryParams": [],
    "bodyParams": [
      "modelId",
      "provider"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agents/:agentId/model/reset": {
    "method": "POST",
    "path": "/agents/:agentId/model/reset",
    "pathParams": [
      "agentId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agents/:agentId/models/reorder": {
    "method": "POST",
    "path": "/agents/:agentId/models/reorder",
    "pathParams": [
      "agentId"
    ],
    "queryParams": [],
    "bodyParams": [
      "reorderedModelIds"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agents/:agentId/models/:modelConfigId": {
    "method": "POST",
    "path": "/agents/:agentId/models/:modelConfigId",
    "pathParams": [
      "agentId",
      "modelConfigId"
    ],
    "queryParams": [],
    "bodyParams": [
      "enabled",
      "maxRetries",
      "model"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agents/:agentId/instructions/enhance": {
    "method": "POST",
    "path": "/agents/:agentId/instructions/enhance",
    "pathParams": [
      "agentId"
    ],
    "queryParams": [],
    "bodyParams": [
      "comment",
      "instructions"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /agents/:agentId/tools/:toolId": {
    "method": "GET",
    "path": "/agents/:agentId/tools/:toolId",
    "pathParams": [
      "agentId",
      "toolId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /agents/:agentId/plans/file": {
    "method": "GET",
    "path": "/agents/:agentId/plans/file",
    "pathParams": [
      "agentId"
    ],
    "queryParams": [
      "path",
      "status",
      "versionId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /agents/:agentId/skills/:skillName": {
    "method": "GET",
    "path": "/agents/:agentId/skills/:skillName",
    "pathParams": [
      "agentId",
      "skillName"
    ],
    "queryParams": [
      "path"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agents/:agentId/voice/listen": {
    "method": "POST",
    "path": "/agents/:agentId/voice/listen",
    "pathParams": [
      "agentId"
    ],
    "queryParams": [],
    "bodyParams": [
      "audio",
      "options"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /agents/:agentId/voice/listener": {
    "method": "GET",
    "path": "/agents/:agentId/voice/listener",
    "pathParams": [
      "agentId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /auth/capabilities": {
    "method": "GET",
    "path": "/auth/capabilities",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /auth/me": {
    "method": "GET",
    "path": "/auth/me",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /auth/roles/:roleId/permissions": {
    "method": "GET",
    "path": "/auth/roles/:roleId/permissions",
    "pathParams": [
      "roleId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "permissions"
    }
  },
  "GET /auth/permission-patterns": {
    "method": "GET",
    "path": "/auth/permission-patterns",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "patterns"
    }
  },
  "GET /workflows": {
    "method": "GET",
    "path": "/workflows",
    "pathParams": [],
    "queryParams": [
      "partial"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "record"
    }
  },
  "GET /workflows/run-counts": {
    "method": "GET",
    "path": "/workflows/run-counts",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "record"
    }
  },
  "GET /workflows/:workflowId": {
    "method": "GET",
    "path": "/workflows/:workflowId",
    "pathParams": [
      "workflowId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /workflows/:workflowId/runs": {
    "method": "GET",
    "path": "/workflows/:workflowId/runs",
    "pathParams": [
      "workflowId"
    ],
    "queryParams": [
      "fromDate",
      "limit",
      "offset",
      "page",
      "perPage",
      "resourceId",
      "status",
      "toDate"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "runs"
    }
  },
  "GET /workflows/:workflowId/runs/:runId": {
    "method": "GET",
    "path": "/workflows/:workflowId/runs/:runId",
    "pathParams": [
      "workflowId",
      "runId"
    ],
    "queryParams": [
      "fields",
      "withNestedWorkflows"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "DELETE /workflows/:workflowId/runs/:runId": {
    "method": "DELETE",
    "path": "/workflows/:workflowId/runs/:runId",
    "pathParams": [
      "workflowId",
      "runId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /workflows/:workflowId/create-run": {
    "method": "POST",
    "path": "/workflows/:workflowId/create-run",
    "pathParams": [
      "workflowId"
    ],
    "queryParams": [
      "runId"
    ],
    "bodyParams": [
      "disableScorers",
      "resourceId"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /workflows/:workflowId/start-async": {
    "method": "POST",
    "path": "/workflows/:workflowId/start-async",
    "pathParams": [
      "workflowId"
    ],
    "queryParams": [
      "runId"
    ],
    "bodyParams": [
      "initialState",
      "inputData",
      "perStep",
      "requestContext",
      "resourceId",
      "tracingOptions"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /workflows/:workflowId/start": {
    "method": "POST",
    "path": "/workflows/:workflowId/start",
    "pathParams": [
      "workflowId"
    ],
    "queryParams": [
      "runId"
    ],
    "bodyParams": [
      "initialState",
      "inputData",
      "perStep",
      "requestContext",
      "resourceId",
      "tracingOptions"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /workflows/:workflowId/resume-async": {
    "method": "POST",
    "path": "/workflows/:workflowId/resume-async",
    "pathParams": [
      "workflowId"
    ],
    "queryParams": [
      "runId"
    ],
    "bodyParams": [
      "forEachIndex",
      "perStep",
      "requestContext",
      "resumeData",
      "step",
      "tracingOptions"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /workflows/:workflowId/resume-no-wait": {
    "method": "POST",
    "path": "/workflows/:workflowId/resume-no-wait",
    "pathParams": [
      "workflowId"
    ],
    "queryParams": [
      "runId"
    ],
    "bodyParams": [
      "forEachIndex",
      "perStep",
      "requestContext",
      "resumeData",
      "step",
      "tracingOptions"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /workflows/:workflowId/resume": {
    "method": "POST",
    "path": "/workflows/:workflowId/resume",
    "pathParams": [
      "workflowId"
    ],
    "queryParams": [
      "runId"
    ],
    "bodyParams": [
      "forEachIndex",
      "perStep",
      "requestContext",
      "resumeData",
      "step",
      "tracingOptions"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /workflows/:workflowId/runs/:runId/cancel": {
    "method": "POST",
    "path": "/workflows/:workflowId/runs/:runId/cancel",
    "pathParams": [
      "workflowId",
      "runId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /workflows/:workflowId/time-travel": {
    "method": "POST",
    "path": "/workflows/:workflowId/time-travel",
    "pathParams": [
      "workflowId"
    ],
    "queryParams": [
      "runId"
    ],
    "bodyParams": [
      "context",
      "initialState",
      "inputData",
      "nestedStepsContext",
      "perStep",
      "requestContext",
      "resumeData",
      "step",
      "tracingOptions"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /workflows/:workflowId/time-travel-async": {
    "method": "POST",
    "path": "/workflows/:workflowId/time-travel-async",
    "pathParams": [
      "workflowId"
    ],
    "queryParams": [
      "runId"
    ],
    "bodyParams": [
      "context",
      "initialState",
      "inputData",
      "nestedStepsContext",
      "perStep",
      "requestContext",
      "resumeData",
      "step",
      "tracingOptions"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /workflows/:workflowId/restart": {
    "method": "POST",
    "path": "/workflows/:workflowId/restart",
    "pathParams": [
      "workflowId"
    ],
    "queryParams": [
      "runId"
    ],
    "bodyParams": [
      "requestContext",
      "tracingOptions"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /workflows/:workflowId/restart-async": {
    "method": "POST",
    "path": "/workflows/:workflowId/restart-async",
    "pathParams": [
      "workflowId"
    ],
    "queryParams": [
      "runId"
    ],
    "bodyParams": [
      "requestContext",
      "tracingOptions"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /workflows/:workflowId/restart-all-active-workflow-runs": {
    "method": "POST",
    "path": "/workflows/:workflowId/restart-all-active-workflow-runs",
    "pathParams": [
      "workflowId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /workflows/:workflowId/restart-all-active-workflow-runs-async": {
    "method": "POST",
    "path": "/workflows/:workflowId/restart-all-active-workflow-runs-async",
    "pathParams": [
      "workflowId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /workflows/:workflowId/runs/:runId/steps/execute": {
    "method": "POST",
    "path": "/workflows/:workflowId/runs/:runId/steps/execute",
    "pathParams": [
      "workflowId",
      "runId"
    ],
    "queryParams": [],
    "bodyParams": [
      "executionPath",
      "foreachIdx",
      "format",
      "input",
      "perStep",
      "requestContext",
      "resumeData",
      "retryCount",
      "state",
      "stepId",
      "stepResults",
      "validateInputs"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /workflows/events": {
    "method": "POST",
    "path": "/workflows/events",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "event"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /tools": {
    "method": "GET",
    "path": "/tools",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "record"
    }
  },
  "GET /tools/:toolId": {
    "method": "GET",
    "path": "/tools/:toolId",
    "pathParams": [
      "toolId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /tools/:toolId/execute": {
    "method": "POST",
    "path": "/tools/:toolId/execute",
    "pathParams": [
      "toolId"
    ],
    "queryParams": [
      "runId"
    ],
    "bodyParams": [
      "data",
      "requestContext"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /processors": {
    "method": "GET",
    "path": "/processors",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "record"
    }
  },
  "GET /processors/:processorId": {
    "method": "GET",
    "path": "/processors/:processorId",
    "pathParams": [
      "processorId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /processors/:processorId/execute": {
    "method": "POST",
    "path": "/processors/:processorId/execute",
    "pathParams": [
      "processorId"
    ],
    "queryParams": [],
    "bodyParams": [
      "agentId",
      "messages",
      "phase",
      "requestContext"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /v1/responses/:responseId": {
    "method": "GET",
    "path": "/v1/responses/:responseId",
    "pathParams": [
      "responseId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "DELETE /v1/responses/:responseId": {
    "method": "DELETE",
    "path": "/v1/responses/:responseId",
    "pathParams": [
      "responseId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /v1/conversations": {
    "method": "POST",
    "path": "/v1/conversations",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "agent_id",
      "conversation_id",
      "metadata",
      "resource_id",
      "title"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /v1/conversations/:conversationId": {
    "method": "GET",
    "path": "/v1/conversations/:conversationId",
    "pathParams": [
      "conversationId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /v1/conversations/:conversationId/items": {
    "method": "GET",
    "path": "/v1/conversations/:conversationId/items",
    "pathParams": [
      "conversationId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "DELETE /v1/conversations/:conversationId": {
    "method": "DELETE",
    "path": "/v1/conversations/:conversationId",
    "pathParams": [
      "conversationId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /memory/status": {
    "method": "GET",
    "path": "/memory/status",
    "pathParams": [],
    "queryParams": [
      "agentId",
      "resourceId",
      "threadId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /memory/config": {
    "method": "GET",
    "path": "/memory/config",
    "pathParams": [],
    "queryParams": [
      "agentId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /memory/observational-memory": {
    "method": "GET",
    "path": "/memory/observational-memory",
    "pathParams": [],
    "queryParams": [
      "agentId",
      "from",
      "limit",
      "offset",
      "resourceId",
      "threadId",
      "to"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "history"
    }
  },
  "POST /memory/observational-memory/buffer-status": {
    "method": "POST",
    "path": "/memory/observational-memory/buffer-status",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "agentId",
      "resourceId",
      "threadId"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /memory/threads": {
    "method": "GET",
    "path": "/memory/threads",
    "pathParams": [],
    "queryParams": [
      "agentId",
      "metadata",
      "orderBy",
      "page",
      "perPage",
      "resourceId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "threads",
      "paginationProperty": "page"
    }
  },
  "GET /memory/threads/:threadId": {
    "method": "GET",
    "path": "/memory/threads/:threadId",
    "pathParams": [
      "threadId"
    ],
    "queryParams": [
      "agentId",
      "resourceId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /memory/threads/:threadId/messages": {
    "method": "GET",
    "path": "/memory/threads/:threadId/messages",
    "pathParams": [
      "threadId"
    ],
    "queryParams": [
      "agentId",
      "filter",
      "include",
      "includeSystemReminders",
      "orderBy",
      "page",
      "perPage",
      "resourceId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "messages"
    }
  },
  "GET /memory/threads/:threadId/working-memory": {
    "method": "GET",
    "path": "/memory/threads/:threadId/working-memory",
    "pathParams": [
      "threadId"
    ],
    "queryParams": [
      "agentId",
      "memoryConfig",
      "resourceId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /memory/save-messages": {
    "method": "POST",
    "path": "/memory/save-messages",
    "pathParams": [],
    "queryParams": [
      "agentId"
    ],
    "bodyParams": [
      "messages"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "messages"
    }
  },
  "POST /memory/threads": {
    "method": "POST",
    "path": "/memory/threads",
    "pathParams": [],
    "queryParams": [
      "agentId"
    ],
    "bodyParams": [
      "metadata",
      "resourceId",
      "threadId",
      "title"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "PATCH /memory/threads/:threadId": {
    "method": "PATCH",
    "path": "/memory/threads/:threadId",
    "pathParams": [
      "threadId"
    ],
    "queryParams": [
      "agentId"
    ],
    "bodyParams": [
      "metadata",
      "resourceId",
      "title"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "DELETE /memory/threads/:threadId": {
    "method": "DELETE",
    "path": "/memory/threads/:threadId",
    "pathParams": [
      "threadId"
    ],
    "queryParams": [
      "agentId",
      "resourceId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /memory/threads/:threadId/clone": {
    "method": "POST",
    "path": "/memory/threads/:threadId/clone",
    "pathParams": [
      "threadId"
    ],
    "queryParams": [
      "agentId"
    ],
    "bodyParams": [
      "metadata",
      "newThreadId",
      "options",
      "resourceId",
      "title"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "clonedMessages"
    }
  },
  "POST /memory/threads/:threadId/working-memory": {
    "method": "POST",
    "path": "/memory/threads/:threadId/working-memory",
    "pathParams": [
      "threadId"
    ],
    "queryParams": [
      "agentId"
    ],
    "bodyParams": [
      "memoryConfig",
      "resourceId",
      "workingMemory"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /memory/messages/delete": {
    "method": "POST",
    "path": "/memory/messages/delete",
    "pathParams": [],
    "queryParams": [
      "agentId",
      "resourceId"
    ],
    "bodyParams": [
      "messageIds"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /memory/search": {
    "method": "GET",
    "path": "/memory/search",
    "pathParams": [],
    "queryParams": [
      "agentId",
      "limit",
      "memoryConfig",
      "resourceId",
      "searchQuery",
      "threadId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /memory/network/status": {
    "method": "GET",
    "path": "/memory/network/status",
    "pathParams": [],
    "queryParams": [
      "agentId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /memory/network/threads": {
    "method": "GET",
    "path": "/memory/network/threads",
    "pathParams": [],
    "queryParams": [
      "agentId",
      "metadata",
      "orderBy",
      "page",
      "perPage",
      "resourceId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "threads",
      "paginationProperty": "page"
    }
  },
  "GET /memory/network/threads/:threadId": {
    "method": "GET",
    "path": "/memory/network/threads/:threadId",
    "pathParams": [
      "threadId"
    ],
    "queryParams": [
      "agentId",
      "resourceId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /memory/network/threads/:threadId/messages": {
    "method": "GET",
    "path": "/memory/network/threads/:threadId/messages",
    "pathParams": [
      "threadId"
    ],
    "queryParams": [
      "agentId",
      "filter",
      "include",
      "orderBy",
      "page",
      "perPage",
      "resourceId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "messages"
    }
  },
  "POST /memory/network/save-messages": {
    "method": "POST",
    "path": "/memory/network/save-messages",
    "pathParams": [],
    "queryParams": [
      "agentId"
    ],
    "bodyParams": [
      "messages"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "messages"
    }
  },
  "POST /memory/network/threads": {
    "method": "POST",
    "path": "/memory/network/threads",
    "pathParams": [],
    "queryParams": [
      "agentId"
    ],
    "bodyParams": [
      "metadata",
      "resourceId",
      "threadId",
      "title"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "PATCH /memory/network/threads/:threadId": {
    "method": "PATCH",
    "path": "/memory/network/threads/:threadId",
    "pathParams": [
      "threadId"
    ],
    "queryParams": [
      "agentId"
    ],
    "bodyParams": [
      "metadata",
      "resourceId",
      "title"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "DELETE /memory/network/threads/:threadId": {
    "method": "DELETE",
    "path": "/memory/network/threads/:threadId",
    "pathParams": [
      "threadId"
    ],
    "queryParams": [
      "agentId",
      "resourceId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /memory/network/messages/delete": {
    "method": "POST",
    "path": "/memory/network/messages/delete",
    "pathParams": [],
    "queryParams": [
      "agentId",
      "resourceId"
    ],
    "bodyParams": [
      "messageIds"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /scores/scorers": {
    "method": "GET",
    "path": "/scores/scorers",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "record"
    }
  },
  "GET /scores/scorers/:scorerId": {
    "method": "GET",
    "path": "/scores/scorers/:scorerId",
    "pathParams": [
      "scorerId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /scores/run/:runId": {
    "method": "GET",
    "path": "/scores/run/:runId",
    "pathParams": [
      "runId"
    ],
    "queryParams": [
      "page",
      "perPage"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "scores",
      "paginationProperty": "pagination"
    }
  },
  "GET /scores/scorer/:scorerId": {
    "method": "GET",
    "path": "/scores/scorer/:scorerId",
    "pathParams": [
      "scorerId"
    ],
    "queryParams": [
      "entityId",
      "entityType",
      "page",
      "perPage"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "scores",
      "paginationProperty": "pagination"
    }
  },
  "GET /scores/entity/:entityType/:entityId": {
    "method": "GET",
    "path": "/scores/entity/:entityType/:entityId",
    "pathParams": [
      "entityType",
      "entityId"
    ],
    "queryParams": [
      "page",
      "perPage"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "scores",
      "paginationProperty": "pagination"
    }
  },
  "POST /scores": {
    "method": "POST",
    "path": "/scores",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "score"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /observability/traces": {
    "method": "GET",
    "path": "/observability/traces",
    "pathParams": [],
    "queryParams": [
      "after",
      "dateRange",
      "direction",
      "endedAt",
      "entityId",
      "entityName",
      "entityType",
      "entityVersionId",
      "environment",
      "experimentId",
      "field",
      "hasChildError",
      "limit",
      "metadata",
      "mode",
      "name",
      "organizationId",
      "page",
      "parentEntityId",
      "parentEntityName",
      "parentEntityType",
      "parentEntityVersionId",
      "perPage",
      "requestId",
      "resourceId",
      "rootEntityId",
      "rootEntityName",
      "rootEntityType",
      "rootEntityVersionId",
      "runId",
      "scope",
      "serviceName",
      "sessionId",
      "source",
      "spanType",
      "startedAt",
      "status",
      "tags",
      "threadId",
      "traceId",
      "userId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "spans",
      "paginationProperty": "pagination"
    }
  },
  "GET /observability/traces/light": {
    "method": "GET",
    "path": "/observability/traces/light",
    "pathParams": [],
    "queryParams": [
      "after",
      "dateRange",
      "direction",
      "endedAt",
      "entityId",
      "entityName",
      "entityType",
      "entityVersionId",
      "environment",
      "experimentId",
      "field",
      "hasChildError",
      "limit",
      "metadata",
      "mode",
      "name",
      "organizationId",
      "page",
      "parentEntityId",
      "parentEntityName",
      "parentEntityType",
      "parentEntityVersionId",
      "perPage",
      "requestId",
      "resourceId",
      "rootEntityId",
      "rootEntityName",
      "rootEntityType",
      "rootEntityVersionId",
      "runId",
      "scope",
      "serviceName",
      "sessionId",
      "source",
      "spanType",
      "startedAt",
      "status",
      "tags",
      "threadId",
      "traceId",
      "userId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "spans",
      "paginationProperty": "pagination"
    }
  },
  "GET /observability/branches": {
    "method": "GET",
    "path": "/observability/branches",
    "pathParams": [],
    "queryParams": [
      "after",
      "direction",
      "endedAt",
      "entityId",
      "entityName",
      "entityType",
      "entityVersionId",
      "environment",
      "experimentId",
      "field",
      "limit",
      "metadata",
      "mode",
      "organizationId",
      "page",
      "parentEntityId",
      "parentEntityName",
      "parentEntityType",
      "parentEntityVersionId",
      "perPage",
      "requestId",
      "resourceId",
      "rootEntityId",
      "rootEntityName",
      "rootEntityType",
      "rootEntityVersionId",
      "runId",
      "scope",
      "serviceName",
      "sessionId",
      "source",
      "spanType",
      "startedAt",
      "status",
      "tags",
      "threadId",
      "traceId",
      "userId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "branches",
      "paginationProperty": "pagination"
    }
  },
  "GET /observability/traces/:traceId/branches/:spanId": {
    "method": "GET",
    "path": "/observability/traces/:traceId/branches/:spanId",
    "pathParams": [
      "traceId",
      "spanId"
    ],
    "queryParams": [
      "depth"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "spans"
    }
  },
  "GET /observability/traces/:traceId": {
    "method": "GET",
    "path": "/observability/traces/:traceId",
    "pathParams": [
      "traceId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "spans"
    }
  },
  "GET /observability/traces/:traceId/light": {
    "method": "GET",
    "path": "/observability/traces/:traceId/light",
    "pathParams": [
      "traceId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "spans"
    }
  },
  "GET /observability/traces/:traceId/spans/:spanId": {
    "method": "GET",
    "path": "/observability/traces/:traceId/spans/:spanId",
    "pathParams": [
      "traceId",
      "spanId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /observability/traces/:traceId/trajectory": {
    "method": "GET",
    "path": "/observability/traces/:traceId/trajectory",
    "pathParams": [
      "traceId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /observability/traces/score": {
    "method": "POST",
    "path": "/observability/traces/score",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "scorerName",
      "targets"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /observability/traces/:traceId/:spanId/scores": {
    "method": "GET",
    "path": "/observability/traces/:traceId/:spanId/scores",
    "pathParams": [
      "traceId",
      "spanId"
    ],
    "queryParams": [
      "page",
      "perPage"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "scores",
      "paginationProperty": "pagination"
    }
  },
  "GET /observability/metrics": {
    "method": "GET",
    "path": "/observability/metrics",
    "pathParams": [],
    "queryParams": [
      "after",
      "costUnit",
      "direction",
      "entityName",
      "entityType",
      "entityVersionId",
      "environment",
      "executionSource",
      "experimentId",
      "field",
      "labels",
      "limit",
      "mode",
      "model",
      "name",
      "organizationId",
      "page",
      "parentEntityName",
      "parentEntityType",
      "parentEntityVersionId",
      "perPage",
      "provider",
      "requestId",
      "resourceId",
      "rootEntityName",
      "rootEntityType",
      "rootEntityVersionId",
      "runId",
      "serviceName",
      "sessionId",
      "source",
      "spanId",
      "tags",
      "threadId",
      "timestamp",
      "traceId",
      "traceIds",
      "userId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "metrics",
      "paginationProperty": "pagination"
    }
  },
  "GET /observability/logs": {
    "method": "GET",
    "path": "/observability/logs",
    "pathParams": [],
    "queryParams": [
      "after",
      "direction",
      "entityName",
      "entityType",
      "entityVersionId",
      "environment",
      "executionSource",
      "experimentId",
      "field",
      "level",
      "limit",
      "mode",
      "organizationId",
      "page",
      "parentEntityName",
      "parentEntityType",
      "parentEntityVersionId",
      "perPage",
      "requestId",
      "resourceId",
      "rootEntityName",
      "rootEntityType",
      "rootEntityVersionId",
      "runId",
      "serviceName",
      "sessionId",
      "source",
      "spanId",
      "tags",
      "threadId",
      "timestamp",
      "traceId",
      "userId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "logs",
      "paginationProperty": "pagination"
    }
  },
  "GET /observability/scores": {
    "method": "GET",
    "path": "/observability/scores",
    "pathParams": [],
    "queryParams": [
      "after",
      "direction",
      "entityName",
      "entityType",
      "entityVersionId",
      "environment",
      "executionSource",
      "experimentId",
      "field",
      "limit",
      "metadata",
      "mode",
      "organizationId",
      "page",
      "parentEntityName",
      "parentEntityType",
      "parentEntityVersionId",
      "perPage",
      "requestId",
      "resourceId",
      "rootEntityName",
      "rootEntityType",
      "rootEntityVersionId",
      "runId",
      "scoreSource",
      "scorerId",
      "serviceName",
      "sessionId",
      "source",
      "spanId",
      "tags",
      "threadId",
      "timestamp",
      "traceId",
      "userId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "scores",
      "paginationProperty": "pagination"
    }
  },
  "POST /observability/scores": {
    "method": "POST",
    "path": "/observability/scores",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "score"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /observability/scores/:scoreId": {
    "method": "GET",
    "path": "/observability/scores/:scoreId",
    "pathParams": [
      "scoreId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /observability/scores/aggregate": {
    "method": "POST",
    "path": "/observability/scores/aggregate",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "aggregation",
      "comparePeriod",
      "filters",
      "scoreSource",
      "scorerId"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /observability/scores/breakdown": {
    "method": "POST",
    "path": "/observability/scores/breakdown",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "aggregation",
      "filters",
      "groupBy",
      "scoreSource",
      "scorerId"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "groups"
    }
  },
  "POST /observability/scores/timeseries": {
    "method": "POST",
    "path": "/observability/scores/timeseries",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "aggregation",
      "filters",
      "groupBy",
      "interval",
      "scoreSource",
      "scorerId"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "series"
    }
  },
  "POST /observability/scores/percentiles": {
    "method": "POST",
    "path": "/observability/scores/percentiles",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "filters",
      "interval",
      "percentiles",
      "scoreSource",
      "scorerId"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "series"
    }
  },
  "GET /observability/feedback": {
    "method": "GET",
    "path": "/observability/feedback",
    "pathParams": [],
    "queryParams": [
      "after",
      "direction",
      "entityName",
      "entityType",
      "entityVersionId",
      "environment",
      "executionSource",
      "experimentId",
      "feedbackSource",
      "feedbackType",
      "feedbackUserId",
      "field",
      "limit",
      "mode",
      "organizationId",
      "page",
      "parentEntityName",
      "parentEntityType",
      "parentEntityVersionId",
      "perPage",
      "requestId",
      "resourceId",
      "rootEntityName",
      "rootEntityType",
      "rootEntityVersionId",
      "runId",
      "serviceName",
      "sessionId",
      "source",
      "spanId",
      "tags",
      "threadId",
      "timestamp",
      "traceId",
      "userId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "feedback",
      "paginationProperty": "pagination"
    }
  },
  "POST /observability/feedback": {
    "method": "POST",
    "path": "/observability/feedback",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "feedback"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /observability/feedback/aggregate": {
    "method": "POST",
    "path": "/observability/feedback/aggregate",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "aggregation",
      "comparePeriod",
      "feedbackSource",
      "feedbackType",
      "filters"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /observability/feedback/breakdown": {
    "method": "POST",
    "path": "/observability/feedback/breakdown",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "aggregation",
      "feedbackSource",
      "feedbackType",
      "filters",
      "groupBy"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "groups"
    }
  },
  "POST /observability/feedback/timeseries": {
    "method": "POST",
    "path": "/observability/feedback/timeseries",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "aggregation",
      "feedbackSource",
      "feedbackType",
      "filters",
      "groupBy",
      "interval"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "series"
    }
  },
  "POST /observability/feedback/percentiles": {
    "method": "POST",
    "path": "/observability/feedback/percentiles",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "feedbackSource",
      "feedbackType",
      "filters",
      "interval",
      "percentiles"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "series"
    }
  },
  "POST /observability/metrics/aggregate": {
    "method": "POST",
    "path": "/observability/metrics/aggregate",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "aggregation",
      "comparePeriod",
      "distinctColumn",
      "filters",
      "name"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /observability/metrics/breakdown": {
    "method": "POST",
    "path": "/observability/metrics/breakdown",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "aggregation",
      "distinctColumn",
      "filters",
      "groupBy",
      "limit",
      "name",
      "orderDirection"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "groups"
    }
  },
  "POST /observability/metrics/timeseries": {
    "method": "POST",
    "path": "/observability/metrics/timeseries",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "aggregation",
      "distinctColumn",
      "filters",
      "groupBy",
      "interval",
      "name"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "series"
    }
  },
  "POST /observability/metrics/percentiles": {
    "method": "POST",
    "path": "/observability/metrics/percentiles",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "filters",
      "interval",
      "name",
      "percentiles"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "series"
    }
  },
  "GET /observability/discovery/metric-names": {
    "method": "GET",
    "path": "/observability/discovery/metric-names",
    "pathParams": [],
    "queryParams": [
      "limit",
      "prefix"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "names"
    }
  },
  "GET /observability/discovery/metric-label-keys": {
    "method": "GET",
    "path": "/observability/discovery/metric-label-keys",
    "pathParams": [],
    "queryParams": [
      "metricName"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "keys"
    }
  },
  "GET /observability/discovery/metric-label-values": {
    "method": "GET",
    "path": "/observability/discovery/metric-label-values",
    "pathParams": [],
    "queryParams": [
      "labelKey",
      "limit",
      "metricName",
      "prefix"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "values"
    }
  },
  "GET /observability/discovery/entity-types": {
    "method": "GET",
    "path": "/observability/discovery/entity-types",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "entityTypes"
    }
  },
  "GET /observability/discovery/entity-names": {
    "method": "GET",
    "path": "/observability/discovery/entity-names",
    "pathParams": [],
    "queryParams": [
      "entityType"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "names"
    }
  },
  "GET /observability/discovery/service-names": {
    "method": "GET",
    "path": "/observability/discovery/service-names",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "serviceNames"
    }
  },
  "GET /observability/discovery/environments": {
    "method": "GET",
    "path": "/observability/discovery/environments",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "environments"
    }
  },
  "GET /observability/discovery/tags": {
    "method": "GET",
    "path": "/observability/discovery/tags",
    "pathParams": [],
    "queryParams": [
      "entityType"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "tags"
    }
  },
  "GET /logs/transports": {
    "method": "GET",
    "path": "/logs/transports",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "transports"
    }
  },
  "GET /logs": {
    "method": "GET",
    "path": "/logs",
    "pathParams": [],
    "queryParams": [
      "filters",
      "fromDate",
      "logLevel",
      "page",
      "perPage",
      "toDate",
      "transportId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "logs",
      "paginationProperty": "page"
    }
  },
  "GET /logs/:runId": {
    "method": "GET",
    "path": "/logs/:runId",
    "pathParams": [
      "runId"
    ],
    "queryParams": [
      "filters",
      "fromDate",
      "logLevel",
      "page",
      "perPage",
      "toDate",
      "transportId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "logs",
      "paginationProperty": "page"
    }
  },
  "POST /vector/:vectorName/upsert": {
    "method": "POST",
    "path": "/vector/:vectorName/upsert",
    "pathParams": [
      "vectorName"
    ],
    "queryParams": [],
    "bodyParams": [
      "ids",
      "indexName",
      "metadata",
      "vectors"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "ids"
    }
  },
  "POST /vector/:vectorName/create-index": {
    "method": "POST",
    "path": "/vector/:vectorName/create-index",
    "pathParams": [
      "vectorName"
    ],
    "queryParams": [],
    "bodyParams": [
      "dimension",
      "indexName",
      "metric"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /vector/:vectorName/query": {
    "method": "POST",
    "path": "/vector/:vectorName/query",
    "pathParams": [
      "vectorName"
    ],
    "queryParams": [],
    "bodyParams": [
      "filter",
      "includeVector",
      "indexName",
      "queryVector",
      "topK"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "array"
    }
  },
  "GET /vector/:vectorName/indexes": {
    "method": "GET",
    "path": "/vector/:vectorName/indexes",
    "pathParams": [
      "vectorName"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "array"
    }
  },
  "GET /vector/:vectorName/indexes/:indexName": {
    "method": "GET",
    "path": "/vector/:vectorName/indexes/:indexName",
    "pathParams": [
      "vectorName",
      "indexName"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "DELETE /vector/:vectorName/indexes/:indexName": {
    "method": "DELETE",
    "path": "/vector/:vectorName/indexes/:indexName",
    "pathParams": [
      "vectorName",
      "indexName"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /vectors": {
    "method": "GET",
    "path": "/vectors",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "vectors"
    }
  },
  "GET /embedders": {
    "method": "GET",
    "path": "/embedders",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "embedders"
    }
  },
  "GET /.well-known/:agentId/agent-card.json": {
    "method": "GET",
    "path": "/.well-known/:agentId/agent-card.json",
    "pathParams": [
      "agentId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /workspaces": {
    "method": "GET",
    "path": "/workspaces",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "workspaces"
    }
  },
  "GET /workspaces/:workspaceId": {
    "method": "GET",
    "path": "/workspaces/:workspaceId",
    "pathParams": [
      "workspaceId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /workspaces/:workspaceId/fs/read": {
    "method": "GET",
    "path": "/workspaces/:workspaceId/fs/read",
    "pathParams": [
      "workspaceId"
    ],
    "queryParams": [
      "encoding",
      "path"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /workspaces/:workspaceId/fs/write": {
    "method": "POST",
    "path": "/workspaces/:workspaceId/fs/write",
    "pathParams": [
      "workspaceId"
    ],
    "queryParams": [],
    "bodyParams": [
      "content",
      "encoding",
      "path",
      "recursive"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /workspaces/:workspaceId/fs/list": {
    "method": "GET",
    "path": "/workspaces/:workspaceId/fs/list",
    "pathParams": [
      "workspaceId"
    ],
    "queryParams": [
      "path",
      "recursive"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "entries"
    }
  },
  "DELETE /workspaces/:workspaceId/fs/delete": {
    "method": "DELETE",
    "path": "/workspaces/:workspaceId/fs/delete",
    "pathParams": [
      "workspaceId"
    ],
    "queryParams": [
      "force",
      "path",
      "recursive"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /workspaces/:workspaceId/fs/mkdir": {
    "method": "POST",
    "path": "/workspaces/:workspaceId/fs/mkdir",
    "pathParams": [
      "workspaceId"
    ],
    "queryParams": [],
    "bodyParams": [
      "path",
      "recursive"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /workspaces/:workspaceId/fs/stat": {
    "method": "GET",
    "path": "/workspaces/:workspaceId/fs/stat",
    "pathParams": [
      "workspaceId"
    ],
    "queryParams": [
      "path"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /workspaces/:workspaceId/search": {
    "method": "GET",
    "path": "/workspaces/:workspaceId/search",
    "pathParams": [
      "workspaceId"
    ],
    "queryParams": [
      "minScore",
      "mode",
      "query",
      "topK"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /workspaces/:workspaceId/index": {
    "method": "POST",
    "path": "/workspaces/:workspaceId/index",
    "pathParams": [
      "workspaceId"
    ],
    "queryParams": [],
    "bodyParams": [
      "content",
      "metadata",
      "path"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /workspaces/:workspaceId/skills/search": {
    "method": "GET",
    "path": "/workspaces/:workspaceId/skills/search",
    "pathParams": [
      "workspaceId"
    ],
    "queryParams": [
      "includeReferences",
      "minScore",
      "query",
      "skillNames",
      "topK"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "results"
    }
  },
  "GET /workspaces/:workspaceId/skills": {
    "method": "GET",
    "path": "/workspaces/:workspaceId/skills",
    "pathParams": [
      "workspaceId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "skills"
    }
  },
  "GET /workspaces/:workspaceId/skills/:skillName": {
    "method": "GET",
    "path": "/workspaces/:workspaceId/skills/:skillName",
    "pathParams": [
      "workspaceId",
      "skillName"
    ],
    "queryParams": [
      "path"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /workspaces/:workspaceId/skills/:skillName/references": {
    "method": "GET",
    "path": "/workspaces/:workspaceId/skills/:skillName/references",
    "pathParams": [
      "workspaceId",
      "skillName"
    ],
    "queryParams": [
      "path"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "references"
    }
  },
  "GET /workspaces/:workspaceId/skills/:skillName/references/:referencePath": {
    "method": "GET",
    "path": "/workspaces/:workspaceId/skills/:skillName/references/:referencePath",
    "pathParams": [
      "workspaceId",
      "skillName",
      "referencePath"
    ],
    "queryParams": [
      "path"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /workspaces/:workspaceId/skills-sh/search": {
    "method": "GET",
    "path": "/workspaces/:workspaceId/skills-sh/search",
    "pathParams": [
      "workspaceId"
    ],
    "queryParams": [
      "limit",
      "q"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /workspaces/:workspaceId/skills-sh/popular": {
    "method": "GET",
    "path": "/workspaces/:workspaceId/skills-sh/popular",
    "pathParams": [
      "workspaceId"
    ],
    "queryParams": [
      "limit",
      "offset"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /workspaces/:workspaceId/skills-sh/preview": {
    "method": "GET",
    "path": "/workspaces/:workspaceId/skills-sh/preview",
    "pathParams": [
      "workspaceId"
    ],
    "queryParams": [
      "owner",
      "path",
      "repo"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /workspaces/:workspaceId/skills-sh/install": {
    "method": "POST",
    "path": "/workspaces/:workspaceId/skills-sh/install",
    "pathParams": [
      "workspaceId"
    ],
    "queryParams": [],
    "bodyParams": [
      "mount",
      "owner",
      "repo",
      "skillName"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /workspaces/:workspaceId/skills-sh/remove": {
    "method": "POST",
    "path": "/workspaces/:workspaceId/skills-sh/remove",
    "pathParams": [
      "workspaceId"
    ],
    "queryParams": [],
    "bodyParams": [
      "skillName"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /workspaces/:workspaceId/skills-sh/update": {
    "method": "POST",
    "path": "/workspaces/:workspaceId/skills-sh/update",
    "pathParams": [
      "workspaceId"
    ],
    "queryParams": [],
    "bodyParams": [
      "skillName"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "updated"
    }
  },
  "POST /agents/:agentId/generate-legacy": {
    "method": "POST",
    "path": "/agents/:agentId/generate-legacy",
    "pathParams": [
      "agentId"
    ],
    "queryParams": [],
    "bodyParams": [
      "activeTools",
      "clientTools",
      "context",
      "instructions",
      "maxSteps",
      "memory",
      "messages",
      "model",
      "modelSettings",
      "output",
      "providerOptions",
      "requestContext",
      "requireToolApproval",
      "resourceId",
      "resourceid",
      "returnScorerData",
      "runId",
      "savePerStep",
      "scorers",
      "stopWhen",
      "structuredOutput",
      "system",
      "threadId",
      "toolChoice",
      "toolsets",
      "tracingOptions",
      "untilIdle",
      "versions"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /mcp/v0/servers": {
    "method": "GET",
    "path": "/mcp/v0/servers",
    "pathParams": [],
    "queryParams": [
      "limit",
      "offset",
      "page",
      "perPage"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /mcp/v0/servers/:id": {
    "method": "GET",
    "path": "/mcp/v0/servers/:id",
    "pathParams": [
      "id"
    ],
    "queryParams": [
      "version"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /mcp/:serverId/tools": {
    "method": "GET",
    "path": "/mcp/:serverId/tools",
    "pathParams": [
      "serverId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "tools"
    }
  },
  "GET /mcp/:serverId/tools/:toolId": {
    "method": "GET",
    "path": "/mcp/:serverId/tools/:toolId",
    "pathParams": [
      "serverId",
      "toolId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /mcp/:serverId/tools/:toolId/execute": {
    "method": "POST",
    "path": "/mcp/:serverId/tools/:toolId/execute",
    "pathParams": [
      "serverId",
      "toolId"
    ],
    "queryParams": [],
    "bodyParams": [
      "data"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /mcp/:serverId/resources": {
    "method": "GET",
    "path": "/mcp/:serverId/resources",
    "pathParams": [
      "serverId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "resources"
    }
  },
  "POST /mcp/:serverId/resources/read": {
    "method": "POST",
    "path": "/mcp/:serverId/resources/read",
    "pathParams": [
      "serverId"
    ],
    "queryParams": [],
    "bodyParams": [
      "uri"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "contents"
    }
  },
  "GET /stored/agents": {
    "method": "GET",
    "path": "/stored/agents",
    "pathParams": [],
    "queryParams": [
      "authorId",
      "favoritedOnly",
      "metadata",
      "orderBy",
      "page",
      "perPage",
      "pinFavoritedFor",
      "status",
      "visibility"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "agents",
      "paginationProperty": "page"
    }
  },
  "POST /stored/agents/preview-instructions": {
    "method": "POST",
    "path": "/stored/agents/preview-instructions",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "blocks",
      "context"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /stored/agents/:storedAgentId/dependents": {
    "method": "GET",
    "path": "/stored/agents/:storedAgentId/dependents",
    "pathParams": [
      "storedAgentId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "dependents"
    }
  },
  "POST /stored/agents/:storedAgentId/export": {
    "method": "POST",
    "path": "/stored/agents/:storedAgentId/export",
    "pathParams": [
      "storedAgentId"
    ],
    "queryParams": [],
    "bodyParams": [
      "agents",
      "browser",
      "defaultOptions",
      "description",
      "durable",
      "inputProcessors",
      "instructions",
      "integrationTools",
      "mcpClients",
      "memory",
      "model",
      "name",
      "outputProcessors",
      "requestContextSchema",
      "scorers",
      "skills",
      "toolProviders",
      "tools",
      "workflows",
      "workspace"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /stored/agents/:storedAgentId/change-request": {
    "method": "POST",
    "path": "/stored/agents/:storedAgentId/change-request",
    "pathParams": [
      "storedAgentId"
    ],
    "queryParams": [],
    "bodyParams": [
      "agents",
      "browser",
      "changeMessage",
      "defaultOptions",
      "description",
      "durable",
      "inputProcessors",
      "inspectOnly",
      "instructions",
      "integrationTools",
      "mcpClients",
      "memory",
      "model",
      "name",
      "outputProcessors",
      "requestContextSchema",
      "scorers",
      "skills",
      "toolProviders",
      "tools",
      "userName",
      "workflows",
      "workspace"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /stored/agents/:storedAgentId": {
    "method": "GET",
    "path": "/stored/agents/:storedAgentId",
    "pathParams": [
      "storedAgentId"
    ],
    "queryParams": [
      "status"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /stored/agents": {
    "method": "POST",
    "path": "/stored/agents",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "agents",
      "authorId",
      "autoPublish",
      "browser",
      "defaultOptions",
      "description",
      "durable",
      "id",
      "inputProcessors",
      "instructions",
      "integrationTools",
      "mcpClients",
      "memory",
      "metadata",
      "model",
      "name",
      "outputProcessors",
      "requestContextSchema",
      "scorers",
      "skills",
      "toolProviders",
      "tools",
      "visibility",
      "workflows",
      "workspace"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "PATCH /stored/agents/:storedAgentId": {
    "method": "PATCH",
    "path": "/stored/agents/:storedAgentId",
    "pathParams": [
      "storedAgentId"
    ],
    "queryParams": [],
    "bodyParams": [
      "agents",
      "authorId",
      "autoPublish",
      "browser",
      "changeMessage",
      "defaultOptions",
      "description",
      "durable",
      "inputProcessors",
      "instructions",
      "integrationTools",
      "mcpClients",
      "memory",
      "metadata",
      "model",
      "name",
      "outputProcessors",
      "requestContextSchema",
      "scorers",
      "skills",
      "toolProviders",
      "tools",
      "visibility",
      "workflows",
      "workspace"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "DELETE /stored/agents/:storedAgentId": {
    "method": "DELETE",
    "path": "/stored/agents/:storedAgentId",
    "pathParams": [
      "storedAgentId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /stored/agents/:agentId/versions": {
    "method": "GET",
    "path": "/stored/agents/:agentId/versions",
    "pathParams": [
      "agentId"
    ],
    "queryParams": [
      "orderBy",
      "page",
      "perPage"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "versions",
      "paginationProperty": "page"
    }
  },
  "POST /stored/agents/:agentId/versions": {
    "method": "POST",
    "path": "/stored/agents/:agentId/versions",
    "pathParams": [
      "agentId"
    ],
    "queryParams": [],
    "bodyParams": [
      "changeMessage"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /stored/agents/:agentId/versions/compare": {
    "method": "GET",
    "path": "/stored/agents/:agentId/versions/compare",
    "pathParams": [
      "agentId"
    ],
    "queryParams": [
      "from",
      "to"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /stored/agents/:agentId/versions/:versionId": {
    "method": "GET",
    "path": "/stored/agents/:agentId/versions/:versionId",
    "pathParams": [
      "agentId",
      "versionId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /stored/agents/:agentId/versions/:versionId/activate": {
    "method": "POST",
    "path": "/stored/agents/:agentId/versions/:versionId/activate",
    "pathParams": [
      "agentId",
      "versionId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /stored/agents/:agentId/versions/:versionId/restore": {
    "method": "POST",
    "path": "/stored/agents/:agentId/versions/:versionId/restore",
    "pathParams": [
      "agentId",
      "versionId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "DELETE /stored/agents/:agentId/versions/:versionId": {
    "method": "DELETE",
    "path": "/stored/agents/:agentId/versions/:versionId",
    "pathParams": [
      "agentId",
      "versionId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "PUT /stored/agents/:storedAgentId/favorite": {
    "method": "PUT",
    "path": "/stored/agents/:storedAgentId/favorite",
    "pathParams": [
      "storedAgentId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "DELETE /stored/agents/:storedAgentId/favorite": {
    "method": "DELETE",
    "path": "/stored/agents/:storedAgentId/favorite",
    "pathParams": [
      "storedAgentId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /stored/workflows": {
    "method": "GET",
    "path": "/stored/workflows",
    "pathParams": [],
    "queryParams": [
      "authorId",
      "status"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "workflows"
    }
  },
  "POST /stored/workflows": {
    "method": "POST",
    "path": "/stored/workflows",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "dependencies",
      "description",
      "graph",
      "id",
      "inputSchema",
      "metadata",
      "outputSchema",
      "requestContextSchema",
      "stateSchema"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /stored/workflows/:dynamicWorkflowId": {
    "method": "GET",
    "path": "/stored/workflows/:dynamicWorkflowId",
    "pathParams": [
      "dynamicWorkflowId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "DELETE /stored/workflows/:dynamicWorkflowId": {
    "method": "DELETE",
    "path": "/stored/workflows/:dynamicWorkflowId",
    "pathParams": [
      "dynamicWorkflowId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /stored/mcp-clients": {
    "method": "GET",
    "path": "/stored/mcp-clients",
    "pathParams": [],
    "queryParams": [
      "authorId",
      "metadata",
      "orderBy",
      "page",
      "perPage",
      "status"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "mcpClients",
      "paginationProperty": "page"
    }
  },
  "GET /stored/mcp-clients/:storedMCPClientId": {
    "method": "GET",
    "path": "/stored/mcp-clients/:storedMCPClientId",
    "pathParams": [
      "storedMCPClientId"
    ],
    "queryParams": [
      "status"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /stored/mcp-clients": {
    "method": "POST",
    "path": "/stored/mcp-clients",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "authorId",
      "description",
      "id",
      "metadata",
      "name",
      "servers"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "PATCH /stored/mcp-clients/:storedMCPClientId": {
    "method": "PATCH",
    "path": "/stored/mcp-clients/:storedMCPClientId",
    "pathParams": [
      "storedMCPClientId"
    ],
    "queryParams": [],
    "bodyParams": [
      "authorId",
      "description",
      "metadata",
      "name",
      "servers"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "DELETE /stored/mcp-clients/:storedMCPClientId": {
    "method": "DELETE",
    "path": "/stored/mcp-clients/:storedMCPClientId",
    "pathParams": [
      "storedMCPClientId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /stored/mcp-clients/:mcpClientId/versions": {
    "method": "GET",
    "path": "/stored/mcp-clients/:mcpClientId/versions",
    "pathParams": [
      "mcpClientId"
    ],
    "queryParams": [
      "orderBy",
      "page",
      "perPage"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "versions",
      "paginationProperty": "page"
    }
  },
  "POST /stored/mcp-clients/:mcpClientId/versions": {
    "method": "POST",
    "path": "/stored/mcp-clients/:mcpClientId/versions",
    "pathParams": [
      "mcpClientId"
    ],
    "queryParams": [],
    "bodyParams": [
      "changeMessage"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /stored/mcp-clients/:mcpClientId/versions/compare": {
    "method": "GET",
    "path": "/stored/mcp-clients/:mcpClientId/versions/compare",
    "pathParams": [
      "mcpClientId"
    ],
    "queryParams": [
      "from",
      "to"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /stored/mcp-clients/:mcpClientId/versions/:versionId": {
    "method": "GET",
    "path": "/stored/mcp-clients/:mcpClientId/versions/:versionId",
    "pathParams": [
      "mcpClientId",
      "versionId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /stored/mcp-clients/:mcpClientId/versions/:versionId/activate": {
    "method": "POST",
    "path": "/stored/mcp-clients/:mcpClientId/versions/:versionId/activate",
    "pathParams": [
      "mcpClientId",
      "versionId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /stored/mcp-clients/:mcpClientId/versions/:versionId/restore": {
    "method": "POST",
    "path": "/stored/mcp-clients/:mcpClientId/versions/:versionId/restore",
    "pathParams": [
      "mcpClientId",
      "versionId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "DELETE /stored/mcp-clients/:mcpClientId/versions/:versionId": {
    "method": "DELETE",
    "path": "/stored/mcp-clients/:mcpClientId/versions/:versionId",
    "pathParams": [
      "mcpClientId",
      "versionId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /stored/prompt-blocks": {
    "method": "GET",
    "path": "/stored/prompt-blocks",
    "pathParams": [],
    "queryParams": [
      "authorId",
      "metadata",
      "orderBy",
      "page",
      "perPage",
      "status"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "promptBlocks",
      "paginationProperty": "page"
    }
  },
  "GET /stored/prompt-blocks/:storedPromptBlockId": {
    "method": "GET",
    "path": "/stored/prompt-blocks/:storedPromptBlockId",
    "pathParams": [
      "storedPromptBlockId"
    ],
    "queryParams": [
      "status"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /stored/prompt-blocks": {
    "method": "POST",
    "path": "/stored/prompt-blocks",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "authorId",
      "content",
      "description",
      "id",
      "metadata",
      "name",
      "requestContextSchema",
      "rules"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "PATCH /stored/prompt-blocks/:storedPromptBlockId": {
    "method": "PATCH",
    "path": "/stored/prompt-blocks/:storedPromptBlockId",
    "pathParams": [
      "storedPromptBlockId"
    ],
    "queryParams": [],
    "bodyParams": [
      "authorId",
      "content",
      "description",
      "metadata",
      "name",
      "requestContextSchema",
      "rules"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "DELETE /stored/prompt-blocks/:storedPromptBlockId": {
    "method": "DELETE",
    "path": "/stored/prompt-blocks/:storedPromptBlockId",
    "pathParams": [
      "storedPromptBlockId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /stored/prompt-blocks/:promptBlockId/versions": {
    "method": "GET",
    "path": "/stored/prompt-blocks/:promptBlockId/versions",
    "pathParams": [
      "promptBlockId"
    ],
    "queryParams": [
      "orderBy",
      "page",
      "perPage"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "versions",
      "paginationProperty": "page"
    }
  },
  "POST /stored/prompt-blocks/:promptBlockId/versions": {
    "method": "POST",
    "path": "/stored/prompt-blocks/:promptBlockId/versions",
    "pathParams": [
      "promptBlockId"
    ],
    "queryParams": [],
    "bodyParams": [
      "changeMessage"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /stored/prompt-blocks/:promptBlockId/versions/compare": {
    "method": "GET",
    "path": "/stored/prompt-blocks/:promptBlockId/versions/compare",
    "pathParams": [
      "promptBlockId"
    ],
    "queryParams": [
      "from",
      "to"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /stored/prompt-blocks/:promptBlockId/versions/:versionId": {
    "method": "GET",
    "path": "/stored/prompt-blocks/:promptBlockId/versions/:versionId",
    "pathParams": [
      "promptBlockId",
      "versionId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /stored/prompt-blocks/:promptBlockId/versions/:versionId/activate": {
    "method": "POST",
    "path": "/stored/prompt-blocks/:promptBlockId/versions/:versionId/activate",
    "pathParams": [
      "promptBlockId",
      "versionId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /stored/prompt-blocks/:promptBlockId/versions/:versionId/restore": {
    "method": "POST",
    "path": "/stored/prompt-blocks/:promptBlockId/versions/:versionId/restore",
    "pathParams": [
      "promptBlockId",
      "versionId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "DELETE /stored/prompt-blocks/:promptBlockId/versions/:versionId": {
    "method": "DELETE",
    "path": "/stored/prompt-blocks/:promptBlockId/versions/:versionId",
    "pathParams": [
      "promptBlockId",
      "versionId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /stored/scorers": {
    "method": "GET",
    "path": "/stored/scorers",
    "pathParams": [],
    "queryParams": [
      "authorId",
      "metadata",
      "orderBy",
      "page",
      "perPage",
      "status"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "scorerDefinitions",
      "paginationProperty": "page"
    }
  },
  "GET /stored/scorers/:storedScorerId": {
    "method": "GET",
    "path": "/stored/scorers/:storedScorerId",
    "pathParams": [
      "storedScorerId"
    ],
    "queryParams": [
      "status"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /stored/scorers": {
    "method": "POST",
    "path": "/stored/scorers",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "authorId",
      "defaultSampling",
      "description",
      "id",
      "instructions",
      "metadata",
      "model",
      "name",
      "presetConfig",
      "scoreRange",
      "type"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "PATCH /stored/scorers/:storedScorerId": {
    "method": "PATCH",
    "path": "/stored/scorers/:storedScorerId",
    "pathParams": [
      "storedScorerId"
    ],
    "queryParams": [],
    "bodyParams": [
      "authorId",
      "defaultSampling",
      "description",
      "instructions",
      "metadata",
      "model",
      "name",
      "presetConfig",
      "scoreRange",
      "type"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "DELETE /stored/scorers/:storedScorerId": {
    "method": "DELETE",
    "path": "/stored/scorers/:storedScorerId",
    "pathParams": [
      "storedScorerId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /stored/scorers/:scorerId/versions": {
    "method": "GET",
    "path": "/stored/scorers/:scorerId/versions",
    "pathParams": [
      "scorerId"
    ],
    "queryParams": [
      "orderBy",
      "page",
      "perPage"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "versions",
      "paginationProperty": "page"
    }
  },
  "POST /stored/scorers/:scorerId/versions": {
    "method": "POST",
    "path": "/stored/scorers/:scorerId/versions",
    "pathParams": [
      "scorerId"
    ],
    "queryParams": [],
    "bodyParams": [
      "changeMessage"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /stored/scorers/:scorerId/versions/compare": {
    "method": "GET",
    "path": "/stored/scorers/:scorerId/versions/compare",
    "pathParams": [
      "scorerId"
    ],
    "queryParams": [
      "from",
      "to"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /stored/scorers/:scorerId/versions/:versionId": {
    "method": "GET",
    "path": "/stored/scorers/:scorerId/versions/:versionId",
    "pathParams": [
      "scorerId",
      "versionId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /stored/scorers/:scorerId/versions/:versionId/activate": {
    "method": "POST",
    "path": "/stored/scorers/:scorerId/versions/:versionId/activate",
    "pathParams": [
      "scorerId",
      "versionId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /stored/scorers/:scorerId/versions/:versionId/restore": {
    "method": "POST",
    "path": "/stored/scorers/:scorerId/versions/:versionId/restore",
    "pathParams": [
      "scorerId",
      "versionId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "DELETE /stored/scorers/:scorerId/versions/:versionId": {
    "method": "DELETE",
    "path": "/stored/scorers/:scorerId/versions/:versionId",
    "pathParams": [
      "scorerId",
      "versionId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /stored/workspaces": {
    "method": "GET",
    "path": "/stored/workspaces",
    "pathParams": [],
    "queryParams": [
      "authorId",
      "metadata",
      "orderBy",
      "page",
      "perPage"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "workspaces",
      "paginationProperty": "page"
    }
  },
  "GET /stored/workspaces/:storedWorkspaceId": {
    "method": "GET",
    "path": "/stored/workspaces/:storedWorkspaceId",
    "pathParams": [
      "storedWorkspaceId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /stored/workspaces": {
    "method": "POST",
    "path": "/stored/workspaces",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "authorId",
      "autoSync",
      "description",
      "filesystem",
      "id",
      "metadata",
      "mounts",
      "name",
      "operationTimeout",
      "sandbox",
      "search",
      "skills",
      "tools"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "PATCH /stored/workspaces/:storedWorkspaceId": {
    "method": "PATCH",
    "path": "/stored/workspaces/:storedWorkspaceId",
    "pathParams": [
      "storedWorkspaceId"
    ],
    "queryParams": [],
    "bodyParams": [
      "autoSync",
      "description",
      "filesystem",
      "metadata",
      "mounts",
      "name",
      "operationTimeout",
      "sandbox",
      "search",
      "skills",
      "tools"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "DELETE /stored/workspaces/:storedWorkspaceId": {
    "method": "DELETE",
    "path": "/stored/workspaces/:storedWorkspaceId",
    "pathParams": [
      "storedWorkspaceId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /stored/skills": {
    "method": "GET",
    "path": "/stored/skills",
    "pathParams": [],
    "queryParams": [
      "authorId",
      "favoritedOnly",
      "metadata",
      "orderBy",
      "page",
      "perPage",
      "pinFavoritedFor",
      "status",
      "visibility"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "skills",
      "paginationProperty": "page"
    }
  },
  "GET /stored/skills/:storedSkillId": {
    "method": "GET",
    "path": "/stored/skills/:storedSkillId",
    "pathParams": [
      "storedSkillId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /stored/skills": {
    "method": "POST",
    "path": "/stored/skills",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "assets",
      "authorId",
      "compatibility",
      "description",
      "files",
      "id",
      "instructions",
      "license",
      "metadata",
      "name",
      "references",
      "scripts",
      "source",
      "visibility"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "PATCH /stored/skills/:storedSkillId": {
    "method": "PATCH",
    "path": "/stored/skills/:storedSkillId",
    "pathParams": [
      "storedSkillId"
    ],
    "queryParams": [],
    "bodyParams": [
      "assets",
      "authorId",
      "compatibility",
      "description",
      "files",
      "instructions",
      "license",
      "metadata",
      "name",
      "references",
      "scripts",
      "source",
      "visibility"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "DELETE /stored/skills/:storedSkillId": {
    "method": "DELETE",
    "path": "/stored/skills/:storedSkillId",
    "pathParams": [
      "storedSkillId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /stored/skills/:storedSkillId/publish": {
    "method": "POST",
    "path": "/stored/skills/:storedSkillId/publish",
    "pathParams": [
      "storedSkillId"
    ],
    "queryParams": [],
    "bodyParams": [
      "skillPath"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "PUT /stored/skills/:storedSkillId/favorite": {
    "method": "PUT",
    "path": "/stored/skills/:storedSkillId/favorite",
    "pathParams": [
      "storedSkillId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "DELETE /stored/skills/:storedSkillId/favorite": {
    "method": "DELETE",
    "path": "/stored/skills/:storedSkillId/favorite",
    "pathParams": [
      "storedSkillId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /tool-providers": {
    "method": "GET",
    "path": "/tool-providers",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "providers"
    }
  },
  "GET /tool-providers/:providerId/toolkits": {
    "method": "GET",
    "path": "/tool-providers/:providerId/toolkits",
    "pathParams": [
      "providerId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "data",
      "paginationProperty": "pagination"
    }
  },
  "GET /tool-providers/:providerId/tools": {
    "method": "GET",
    "path": "/tool-providers/:providerId/tools",
    "pathParams": [
      "providerId"
    ],
    "queryParams": [
      "page",
      "perPage",
      "search",
      "toolkit"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "data",
      "paginationProperty": "pagination"
    }
  },
  "GET /tool-providers/:providerId/tools/:toolSlug/schema": {
    "method": "GET",
    "path": "/tool-providers/:providerId/tools/:toolSlug/schema",
    "pathParams": [
      "providerId",
      "toolSlug"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "record"
    }
  },
  "POST /tool-providers/:providerId/authorize": {
    "method": "POST",
    "path": "/tool-providers/:providerId/authorize",
    "pathParams": [
      "providerId"
    ],
    "queryParams": [],
    "bodyParams": [
      "config",
      "connectionId",
      "label",
      "scope",
      "toolName",
      "toolkit"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /tool-providers/:providerId/auth-status/:authId": {
    "method": "GET",
    "path": "/tool-providers/:providerId/auth-status/:authId",
    "pathParams": [
      "providerId",
      "authId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /tool-providers/:providerId/connection-status": {
    "method": "POST",
    "path": "/tool-providers/:providerId/connection-status",
    "pathParams": [
      "providerId"
    ],
    "queryParams": [],
    "bodyParams": [
      "items"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /tool-providers/:providerId/connections": {
    "method": "GET",
    "path": "/tool-providers/:providerId/connections",
    "pathParams": [
      "providerId"
    ],
    "queryParams": [
      "authorId",
      "page",
      "perPage",
      "scope",
      "toolkit"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "items",
      "paginationProperty": "pagination"
    }
  },
  "GET /tool-providers/:providerId/connection-fields": {
    "method": "GET",
    "path": "/tool-providers/:providerId/connection-fields",
    "pathParams": [
      "providerId"
    ],
    "queryParams": [
      "toolkit"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "fields"
    }
  },
  "DELETE /tool-providers/:providerId/connections/:connectionId": {
    "method": "DELETE",
    "path": "/tool-providers/:providerId/connections/:connectionId",
    "pathParams": [
      "providerId",
      "connectionId"
    ],
    "queryParams": [
      "force",
      "toolkit"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "PATCH /tool-providers/:providerId/connections/:connectionId": {
    "method": "PATCH",
    "path": "/tool-providers/:providerId/connections/:connectionId",
    "pathParams": [
      "providerId",
      "connectionId"
    ],
    "queryParams": [],
    "bodyParams": [
      "label"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /tool-providers/:providerId/connections/:connectionId/usage": {
    "method": "GET",
    "path": "/tool-providers/:providerId/connections/:connectionId/usage",
    "pathParams": [
      "providerId",
      "connectionId"
    ],
    "queryParams": [
      "toolkit"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "agents"
    }
  },
  "GET /tool-providers/:providerId/health": {
    "method": "GET",
    "path": "/tool-providers/:providerId/health",
    "pathParams": [
      "providerId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /processor-providers": {
    "method": "GET",
    "path": "/processor-providers",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "providers"
    }
  },
  "GET /processor-providers/:providerId": {
    "method": "GET",
    "path": "/processor-providers/:providerId",
    "pathParams": [
      "providerId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /system/packages": {
    "method": "GET",
    "path": "/system/packages",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /system/api-schema": {
    "method": "GET",
    "path": "/system/api-schema",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "routes"
    }
  },
  "GET /datasets": {
    "method": "GET",
    "path": "/datasets",
    "pathParams": [],
    "queryParams": [
      "page",
      "perPage"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "datasets",
      "paginationProperty": "pagination"
    }
  },
  "POST /datasets": {
    "method": "POST",
    "path": "/datasets",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "description",
      "groundTruthSchema",
      "inputSchema",
      "metadata",
      "name",
      "requestContextSchema",
      "scorerIds",
      "targetIds",
      "targetType"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /datasets/:datasetId": {
    "method": "GET",
    "path": "/datasets/:datasetId",
    "pathParams": [
      "datasetId"
    ],
    "queryParams": [
      "organizationId",
      "projectId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "PATCH /datasets/:datasetId": {
    "method": "PATCH",
    "path": "/datasets/:datasetId",
    "pathParams": [
      "datasetId"
    ],
    "queryParams": [
      "organizationId",
      "projectId"
    ],
    "bodyParams": [
      "description",
      "groundTruthSchema",
      "inputSchema",
      "metadata",
      "name",
      "requestContextSchema",
      "scorerIds",
      "tags",
      "targetIds",
      "targetType"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "DELETE /datasets/:datasetId": {
    "method": "DELETE",
    "path": "/datasets/:datasetId",
    "pathParams": [
      "datasetId"
    ],
    "queryParams": [
      "organizationId",
      "projectId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /datasets/:datasetId/items": {
    "method": "GET",
    "path": "/datasets/:datasetId/items",
    "pathParams": [
      "datasetId"
    ],
    "queryParams": [
      "page",
      "perPage",
      "search",
      "version"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "items",
      "paginationProperty": "pagination"
    }
  },
  "POST /datasets/:datasetId/items": {
    "method": "POST",
    "path": "/datasets/:datasetId/items",
    "pathParams": [
      "datasetId"
    ],
    "queryParams": [],
    "bodyParams": [
      "expectedTrajectory",
      "externalId",
      "groundTruth",
      "input",
      "metadata",
      "requestContext",
      "scorerIds",
      "source",
      "toolMocks",
      "unmockedToolPolicy"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /datasets/:datasetId/items/batch": {
    "method": "POST",
    "path": "/datasets/:datasetId/items/batch",
    "pathParams": [
      "datasetId"
    ],
    "queryParams": [],
    "bodyParams": [
      "items"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "items"
    }
  },
  "DELETE /datasets/:datasetId/items/batch": {
    "method": "DELETE",
    "path": "/datasets/:datasetId/items/batch",
    "pathParams": [
      "datasetId"
    ],
    "queryParams": [],
    "bodyParams": [
      "itemIds"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /datasets/:datasetId/items/:itemId": {
    "method": "GET",
    "path": "/datasets/:datasetId/items/:itemId",
    "pathParams": [
      "datasetId",
      "itemId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "PATCH /datasets/:datasetId/items/:itemId": {
    "method": "PATCH",
    "path": "/datasets/:datasetId/items/:itemId",
    "pathParams": [
      "datasetId",
      "itemId"
    ],
    "queryParams": [],
    "bodyParams": [
      "expectedTrajectory",
      "groundTruth",
      "input",
      "metadata",
      "requestContext",
      "scorerIds",
      "source",
      "toolMocks",
      "unmockedToolPolicy"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "DELETE /datasets/:datasetId/items/:itemId": {
    "method": "DELETE",
    "path": "/datasets/:datasetId/items/:itemId",
    "pathParams": [
      "datasetId",
      "itemId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /datasets/:datasetId/versions": {
    "method": "GET",
    "path": "/datasets/:datasetId/versions",
    "pathParams": [
      "datasetId"
    ],
    "queryParams": [
      "page",
      "perPage"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "versions",
      "paginationProperty": "pagination"
    }
  },
  "GET /datasets/:datasetId/items/:itemId/history": {
    "method": "GET",
    "path": "/datasets/:datasetId/items/:itemId/history",
    "pathParams": [
      "datasetId",
      "itemId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "history"
    }
  },
  "GET /datasets/:datasetId/items/:itemId/versions/:datasetVersion": {
    "method": "GET",
    "path": "/datasets/:datasetId/items/:itemId/versions/:datasetVersion",
    "pathParams": [
      "datasetId",
      "itemId",
      "datasetVersion"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /experiments": {
    "method": "GET",
    "path": "/experiments",
    "pathParams": [],
    "queryParams": [
      "comparisonId",
      "experimentSetId",
      "page",
      "perPage",
      "trialIndex",
      "variantId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "experiments",
      "paginationProperty": "pagination"
    }
  },
  "GET /experiments/review-summary": {
    "method": "GET",
    "path": "/experiments/review-summary",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "counts"
    }
  },
  "GET /datasets/:datasetId/experiments": {
    "method": "GET",
    "path": "/datasets/:datasetId/experiments",
    "pathParams": [
      "datasetId"
    ],
    "queryParams": [
      "comparisonId",
      "experimentSetId",
      "page",
      "perPage",
      "trialIndex",
      "variantId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "experiments",
      "paginationProperty": "pagination"
    }
  },
  "POST /datasets/:datasetId/experiments": {
    "method": "POST",
    "path": "/datasets/:datasetId/experiments",
    "pathParams": [
      "datasetId"
    ],
    "queryParams": [],
    "bodyParams": [
      "agentVersion",
      "description",
      "grouping",
      "id",
      "maxConcurrency",
      "metadata",
      "name",
      "provenance",
      "requestContext",
      "scorerIds",
      "start",
      "targetId",
      "targetType",
      "version",
      "versions"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /datasets/:datasetId/experiments/:experimentId/items/:itemId/run": {
    "method": "POST",
    "path": "/datasets/:datasetId/experiments/:experimentId/items/:itemId/run",
    "pathParams": [
      "datasetId",
      "experimentId",
      "itemId"
    ],
    "queryParams": [],
    "bodyParams": [
      "attempt",
      "requestContext"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "scores"
    }
  },
  "POST /datasets/:datasetId/experiments/:experimentId/results": {
    "method": "POST",
    "path": "/datasets/:datasetId/experiments/:experimentId/results",
    "pathParams": [
      "datasetId",
      "experimentId"
    ],
    "queryParams": [],
    "bodyParams": [
      "attempt",
      "completedAt",
      "error",
      "groundTruth",
      "input",
      "itemId",
      "output",
      "scores",
      "startedAt",
      "traceId"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /datasets/:datasetId/experiments/:experimentId/finalize": {
    "method": "POST",
    "path": "/datasets/:datasetId/experiments/:experimentId/finalize",
    "pathParams": [
      "datasetId",
      "experimentId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /datasets/:datasetId/experiments/:experimentId": {
    "method": "GET",
    "path": "/datasets/:datasetId/experiments/:experimentId",
    "pathParams": [
      "datasetId",
      "experimentId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /datasets/:datasetId/experiments/:experimentId/results": {
    "method": "GET",
    "path": "/datasets/:datasetId/experiments/:experimentId/results",
    "pathParams": [
      "datasetId",
      "experimentId"
    ],
    "queryParams": [
      "page",
      "perPage"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "results",
      "paginationProperty": "pagination"
    }
  },
  "PATCH /datasets/:datasetId/experiments/:experimentId/results/:resultId": {
    "method": "PATCH",
    "path": "/datasets/:datasetId/experiments/:experimentId/results/:resultId",
    "pathParams": [
      "datasetId",
      "experimentId",
      "resultId"
    ],
    "queryParams": [],
    "bodyParams": [
      "comment",
      "status",
      "tags"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /datasets/:datasetId/compare": {
    "method": "POST",
    "path": "/datasets/:datasetId/compare",
    "pathParams": [
      "datasetId"
    ],
    "queryParams": [],
    "bodyParams": [
      "experimentIdA",
      "experimentIdB"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "items"
    }
  },
  "POST /datasets/:datasetId/generate-items": {
    "method": "POST",
    "path": "/datasets/:datasetId/generate-items",
    "pathParams": [
      "datasetId"
    ],
    "queryParams": [],
    "bodyParams": [
      "agentContext",
      "count",
      "modelId",
      "prompt"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "items"
    }
  },
  "POST /datasets/cluster-failures": {
    "method": "POST",
    "path": "/datasets/cluster-failures",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "availableTags",
      "items",
      "modelId",
      "prompt"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "clusters"
    }
  },
  "GET /background-tasks": {
    "method": "GET",
    "path": "/background-tasks",
    "pathParams": [],
    "queryParams": [
      "agentId",
      "dateFilterBy",
      "fromDate",
      "orderBy",
      "orderDirection",
      "page",
      "perPage",
      "resourceId",
      "runId",
      "status",
      "threadId",
      "toDate",
      "toolCallId",
      "toolName"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "tasks"
    }
  },
  "GET /background-tasks/:backgroundTaskId": {
    "method": "GET",
    "path": "/background-tasks/:backgroundTaskId",
    "pathParams": [
      "backgroundTaskId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /editor/builder/settings": {
    "method": "GET",
    "path": "/editor/builder/settings",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /editor/builder/models/available": {
    "method": "GET",
    "path": "/editor/builder/models/available",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "providers"
    }
  },
  "GET /editor/builder/infrastructure": {
    "method": "GET",
    "path": "/editor/builder/infrastructure",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /editor/builder/registries": {
    "method": "GET",
    "path": "/editor/builder/registries",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "registries"
    }
  },
  "GET /editor/builder/registries/:registryId/search": {
    "method": "GET",
    "path": "/editor/builder/registries/:registryId/search",
    "pathParams": [
      "registryId"
    ],
    "queryParams": [
      "limit",
      "q"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /editor/builder/registries/:registryId/popular": {
    "method": "GET",
    "path": "/editor/builder/registries/:registryId/popular",
    "pathParams": [
      "registryId"
    ],
    "queryParams": [
      "limit",
      "offset"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /editor/builder/registries/:registryId/preview": {
    "method": "GET",
    "path": "/editor/builder/registries/:registryId/preview",
    "pathParams": [
      "registryId"
    ],
    "queryParams": [
      "owner",
      "path",
      "repo"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /editor/builder/registries/:registryId/install": {
    "method": "POST",
    "path": "/editor/builder/registries/:registryId/install",
    "pathParams": [
      "registryId"
    ],
    "queryParams": [],
    "bodyParams": [
      "owner",
      "repo",
      "skillName",
      "visibility"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /agent-builder": {
    "method": "GET",
    "path": "/agent-builder",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "record"
    }
  },
  "GET /agent-builder/:actionId": {
    "method": "GET",
    "path": "/agent-builder/:actionId",
    "pathParams": [
      "actionId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /agent-builder/:actionId/runs": {
    "method": "GET",
    "path": "/agent-builder/:actionId/runs",
    "pathParams": [
      "actionId"
    ],
    "queryParams": [
      "fromDate",
      "limit",
      "offset",
      "page",
      "perPage",
      "resourceId",
      "status",
      "toDate"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "runs"
    }
  },
  "GET /agent-builder/:actionId/runs/:runId": {
    "method": "GET",
    "path": "/agent-builder/:actionId/runs/:runId",
    "pathParams": [
      "actionId",
      "runId"
    ],
    "queryParams": [
      "fields",
      "withNestedWorkflows"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agent-builder/:actionId/create-run": {
    "method": "POST",
    "path": "/agent-builder/:actionId/create-run",
    "pathParams": [
      "actionId"
    ],
    "queryParams": [
      "runId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agent-builder/:actionId/start-async": {
    "method": "POST",
    "path": "/agent-builder/:actionId/start-async",
    "pathParams": [
      "actionId"
    ],
    "queryParams": [
      "runId"
    ],
    "bodyParams": [
      "initialState",
      "inputData",
      "perStep",
      "requestContext",
      "resourceId",
      "tracingOptions"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agent-builder/:actionId/start": {
    "method": "POST",
    "path": "/agent-builder/:actionId/start",
    "pathParams": [
      "actionId"
    ],
    "queryParams": [
      "runId"
    ],
    "bodyParams": [
      "initialState",
      "inputData",
      "perStep",
      "requestContext",
      "resourceId",
      "tracingOptions"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agent-builder/:actionId/resume-async": {
    "method": "POST",
    "path": "/agent-builder/:actionId/resume-async",
    "pathParams": [
      "actionId"
    ],
    "queryParams": [
      "runId"
    ],
    "bodyParams": [
      "forEachIndex",
      "perStep",
      "requestContext",
      "resumeData",
      "step",
      "tracingOptions"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agent-builder/:actionId/resume-no-wait": {
    "method": "POST",
    "path": "/agent-builder/:actionId/resume-no-wait",
    "pathParams": [
      "actionId"
    ],
    "queryParams": [
      "runId"
    ],
    "bodyParams": [
      "forEachIndex",
      "perStep",
      "requestContext",
      "resumeData",
      "step",
      "tracingOptions"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agent-builder/:actionId/resume": {
    "method": "POST",
    "path": "/agent-builder/:actionId/resume",
    "pathParams": [
      "actionId"
    ],
    "queryParams": [
      "runId"
    ],
    "bodyParams": [
      "forEachIndex",
      "perStep",
      "requestContext",
      "resumeData",
      "step",
      "tracingOptions"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agent-builder/:actionId/runs/:runId/cancel": {
    "method": "POST",
    "path": "/agent-builder/:actionId/runs/:runId/cancel",
    "pathParams": [
      "actionId",
      "runId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /schedules": {
    "method": "GET",
    "path": "/schedules",
    "pathParams": [],
    "queryParams": [
      "agentId",
      "name",
      "resourceId",
      "status",
      "threadId",
      "workflowId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "schedules"
    }
  },
  "GET /schedules/:scheduleId": {
    "method": "GET",
    "path": "/schedules/:scheduleId",
    "pathParams": [
      "scheduleId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /schedules": {
    "method": "POST",
    "path": "/schedules",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "PATCH /schedules/:scheduleId": {
    "method": "PATCH",
    "path": "/schedules/:scheduleId",
    "pathParams": [
      "scheduleId"
    ],
    "queryParams": [],
    "bodyParams": [
      "attributes",
      "cron",
      "ifActive",
      "ifIdle",
      "initialState",
      "inputData",
      "metadata",
      "name",
      "prompt",
      "providerOptions",
      "requestContext",
      "signalType",
      "status",
      "tagName",
      "timezone"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "DELETE /schedules/:scheduleId": {
    "method": "DELETE",
    "path": "/schedules/:scheduleId",
    "pathParams": [
      "scheduleId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /schedules/:scheduleId/triggers": {
    "method": "GET",
    "path": "/schedules/:scheduleId/triggers",
    "pathParams": [
      "scheduleId"
    ],
    "queryParams": [
      "fromActualFireAt",
      "limit",
      "toActualFireAt"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "triggers"
    }
  },
  "POST /schedules/:scheduleId/pause": {
    "method": "POST",
    "path": "/schedules/:scheduleId/pause",
    "pathParams": [
      "scheduleId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /schedules/:scheduleId/resume": {
    "method": "POST",
    "path": "/schedules/:scheduleId/resume",
    "pathParams": [
      "scheduleId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /schedules/:scheduleId/run": {
    "method": "POST",
    "path": "/schedules/:scheduleId/run",
    "pathParams": [
      "scheduleId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /channels/platforms": {
    "method": "GET",
    "path": "/channels/platforms",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "array"
    }
  },
  "GET /channels/:platform/installations": {
    "method": "GET",
    "path": "/channels/:platform/installations",
    "pathParams": [
      "platform"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "array"
    }
  },
  "POST /channels/:platform/connect": {
    "method": "POST",
    "path": "/channels/:platform/connect",
    "pathParams": [
      "platform"
    ],
    "queryParams": [],
    "bodyParams": [
      "agentId",
      "options"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /channels/:platform/:agentId/disconnect": {
    "method": "POST",
    "path": "/channels/:platform/:agentId/disconnect",
    "pathParams": [
      "platform",
      "agentId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /agent-controller": {
    "method": "GET",
    "path": "/agent-controller",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "agentControllers"
    }
  },
  "GET /agent-controller/:controllerId/modes": {
    "method": "GET",
    "path": "/agent-controller/:controllerId/modes",
    "pathParams": [
      "controllerId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "modes"
    }
  },
  "GET /agent-controller/:controllerId/models": {
    "method": "GET",
    "path": "/agent-controller/:controllerId/models",
    "pathParams": [
      "controllerId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "models"
    }
  },
  "GET /agent-controller/:controllerId/active-runs": {
    "method": "GET",
    "path": "/agent-controller/:controllerId/active-runs",
    "pathParams": [
      "controllerId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "runs"
    }
  },
  "POST /agent-controller/:controllerId/sessions": {
    "method": "POST",
    "path": "/agent-controller/:controllerId/sessions",
    "pathParams": [
      "controllerId"
    ],
    "queryParams": [],
    "bodyParams": [
      "resourceId",
      "sessionScope",
      "tags",
      "threadId"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /agent-controller/:controllerId/sessions/:resourceId": {
    "method": "GET",
    "path": "/agent-controller/:controllerId/sessions/:resourceId",
    "pathParams": [
      "controllerId",
      "resourceId"
    ],
    "queryParams": [
      "sessionScope",
      "threadId"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /agent-controller/:controllerId/sessions/:resourceId/threads": {
    "method": "GET",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/threads",
    "pathParams": [
      "controllerId",
      "resourceId"
    ],
    "queryParams": [
      "limit",
      "sessionScope",
      "tags"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "threads"
    }
  },
  "POST /agent-controller/:controllerId/sessions/:resourceId/threads": {
    "method": "POST",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/threads",
    "pathParams": [
      "controllerId",
      "resourceId"
    ],
    "queryParams": [
      "sessionScope"
    ],
    "bodyParams": [
      "title"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "DELETE /agent-controller/:controllerId/sessions/:resourceId/threads/:threadId": {
    "method": "DELETE",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/threads/:threadId",
    "pathParams": [
      "controllerId",
      "resourceId",
      "threadId"
    ],
    "queryParams": [
      "sessionScope"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "PUT /agent-controller/:controllerId/sessions/:resourceId/threads/:threadId": {
    "method": "PUT",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/threads/:threadId",
    "pathParams": [
      "controllerId",
      "resourceId",
      "threadId"
    ],
    "queryParams": [
      "sessionScope"
    ],
    "bodyParams": [
      "title"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agent-controller/:controllerId/sessions/:resourceId/threads/clone": {
    "method": "POST",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/threads/clone",
    "pathParams": [
      "controllerId",
      "resourceId"
    ],
    "queryParams": [
      "sessionScope"
    ],
    "bodyParams": [
      "sourceThreadId",
      "title"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /agent-controller/:controllerId/sessions/:resourceId/threads/:threadId/messages": {
    "method": "GET",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/threads/:threadId/messages",
    "pathParams": [
      "controllerId",
      "resourceId",
      "threadId"
    ],
    "queryParams": [
      "limit",
      "sessionScope"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "messages"
    }
  },
  "POST /agent-controller/:controllerId/sessions/:resourceId/messages": {
    "method": "POST",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/messages",
    "pathParams": [
      "controllerId",
      "resourceId"
    ],
    "queryParams": [
      "sessionScope"
    ],
    "bodyParams": [
      "files",
      "message",
      "requestContext"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agent-controller/:controllerId/sessions/:resourceId/steer": {
    "method": "POST",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/steer",
    "pathParams": [
      "controllerId",
      "resourceId"
    ],
    "queryParams": [
      "sessionScope"
    ],
    "bodyParams": [
      "message",
      "requestContext"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agent-controller/:controllerId/sessions/:resourceId/follow-up": {
    "method": "POST",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/follow-up",
    "pathParams": [
      "controllerId",
      "resourceId"
    ],
    "queryParams": [
      "sessionScope"
    ],
    "bodyParams": [
      "message",
      "requestContext"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agent-controller/:controllerId/sessions/:resourceId/abort": {
    "method": "POST",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/abort",
    "pathParams": [
      "controllerId",
      "resourceId"
    ],
    "queryParams": [
      "sessionScope"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agent-controller/:controllerId/sessions/:resourceId/tool-approval": {
    "method": "POST",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/tool-approval",
    "pathParams": [
      "controllerId",
      "resourceId"
    ],
    "queryParams": [
      "sessionScope"
    ],
    "bodyParams": [
      "approved",
      "requestContext",
      "toolCallId"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agent-controller/:controllerId/sessions/:resourceId/tool-suspension": {
    "method": "POST",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/tool-suspension",
    "pathParams": [
      "controllerId",
      "resourceId"
    ],
    "queryParams": [
      "sessionScope"
    ],
    "bodyParams": [
      "requestContext",
      "resumeData",
      "toolCallId"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agent-controller/:controllerId/sessions/:resourceId/mode": {
    "method": "POST",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/mode",
    "pathParams": [
      "controllerId",
      "resourceId"
    ],
    "queryParams": [
      "sessionScope"
    ],
    "bodyParams": [
      "modeId"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agent-controller/:controllerId/sessions/:resourceId/model": {
    "method": "POST",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/model",
    "pathParams": [
      "controllerId",
      "resourceId"
    ],
    "queryParams": [
      "sessionScope"
    ],
    "bodyParams": [
      "modeId",
      "modelId",
      "scope"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agent-controller/:controllerId/sessions/:resourceId/thread": {
    "method": "POST",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/thread",
    "pathParams": [
      "controllerId",
      "resourceId"
    ],
    "queryParams": [
      "sessionScope"
    ],
    "bodyParams": [
      "threadId"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agent-controller/:controllerId/sessions/:resourceId/notifications": {
    "method": "POST",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/notifications",
    "pathParams": [
      "controllerId",
      "resourceId"
    ],
    "queryParams": [
      "sessionScope"
    ],
    "bodyParams": [
      "attributes",
      "coalesceKey",
      "dedupeKey",
      "kind",
      "metadata",
      "payload",
      "priority",
      "source",
      "sourceId",
      "summary"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /agent-controller/:controllerId/workspace": {
    "method": "GET",
    "path": "/agent-controller/:controllerId/workspace",
    "pathParams": [
      "controllerId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /agent-controller/:controllerId/sessions/:resourceId/om": {
    "method": "GET",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/om",
    "pathParams": [
      "controllerId",
      "resourceId"
    ],
    "queryParams": [
      "sessionScope"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agent-controller/:controllerId/sessions/:resourceId/resource": {
    "method": "POST",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/resource",
    "pathParams": [
      "controllerId",
      "resourceId"
    ],
    "queryParams": [
      "sessionScope"
    ],
    "bodyParams": [
      "newResourceId"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /agent-controller/:controllerId/sessions/:resourceId/resources": {
    "method": "GET",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/resources",
    "pathParams": [
      "controllerId",
      "resourceId"
    ],
    "queryParams": [
      "sessionScope"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "resourceIds"
    }
  },
  "GET /agent-controller/:controllerId/sessions/:resourceId/goal": {
    "method": "GET",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/goal",
    "pathParams": [
      "controllerId",
      "resourceId"
    ],
    "queryParams": [
      "sessionScope"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /agent-controller/:controllerId/sessions/:resourceId/goal": {
    "method": "POST",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/goal",
    "pathParams": [
      "controllerId",
      "resourceId"
    ],
    "queryParams": [
      "sessionScope"
    ],
    "bodyParams": [
      "judgeModelId",
      "maxRuns",
      "objective"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "PUT /agent-controller/:controllerId/sessions/:resourceId/goal": {
    "method": "PUT",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/goal",
    "pathParams": [
      "controllerId",
      "resourceId"
    ],
    "queryParams": [
      "sessionScope"
    ],
    "bodyParams": [
      "judgeModelId",
      "maxRuns",
      "status"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "DELETE /agent-controller/:controllerId/sessions/:resourceId/goal": {
    "method": "DELETE",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/goal",
    "pathParams": [
      "controllerId",
      "resourceId"
    ],
    "queryParams": [
      "sessionScope"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /agent-controller/:controllerId/sessions/:resourceId/permissions": {
    "method": "GET",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/permissions",
    "pathParams": [
      "controllerId",
      "resourceId"
    ],
    "queryParams": [
      "sessionScope"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "PUT /agent-controller/:controllerId/sessions/:resourceId/permissions/category": {
    "method": "PUT",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/permissions/category",
    "pathParams": [
      "controllerId",
      "resourceId"
    ],
    "queryParams": [
      "sessionScope"
    ],
    "bodyParams": [
      "category",
      "policy"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "PUT /agent-controller/:controllerId/sessions/:resourceId/permissions/tool": {
    "method": "PUT",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/permissions/tool",
    "pathParams": [
      "controllerId",
      "resourceId"
    ],
    "queryParams": [
      "sessionScope"
    ],
    "bodyParams": [
      "policy",
      "toolName"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "PUT /agent-controller/:controllerId/sessions/:resourceId/state": {
    "method": "PUT",
    "path": "/agent-controller/:controllerId/sessions/:resourceId/state",
    "pathParams": [
      "controllerId",
      "resourceId"
    ],
    "queryParams": [
      "sessionScope"
    ],
    "bodyParams": [
      "state"
    ],
    "hasQuery": true,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  }
} as const;
